import { IRotarySteerableFactor } from '../../interfaces/irotary-steerable-factor';
import { AssetTeam } from '../asset-team';

export class RotarySteerableFactorBase {
  RotarySteerableFactorId: number;
  IsSteerable: boolean;
  AssetTeamId: number;
  Factor: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AssetTeam?: AssetTeam;

  constructor(item?: IRotarySteerableFactor) {
    if (item) {

      this.RotarySteerableFactorId = item.RotarySteerableFactorId;
      this.IsSteerable = item.IsSteerable;
      this.AssetTeamId = item.AssetTeamId;
      this.Factor = item.Factor;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AssetTeam = new AssetTeam(item.AssetTeam);
    }
  }
}